<template>
<!--this is gonna contain all the steps for a given product-->
    <LcForm :formData="this.formData"
        v-model:application-settings="this.applicationSettings"
        @completed.once="this.componentSettings.isCompleted = true"
    />
</template>

<script>

// this is the new 2025 version of InitialFlow.vue
import LcForm from '@/components/form/LcForm.vue';
import {getSteps} from "@/form/helpers/steps-per-product.js";

export default {
    name: 'RegularApplicationFlow',
    components: {
        LcForm
    },
    props: {
        productName: {
            type: String,
            required: false,
            default: 'personal_loan',
        },
        applicationSettings: {
            type: Object,
            required: true,
        },
        componentSettings: {
            type: Object,
            required: true,
        },
    },
    data: () => {
        const formData = {
            steps: null
        };

        return {
            formData,
        };
    },
    methods: {
    },
    computed: {
        isComponentVisible() {
            return !!this.componentSettings.isVisible;
        },
    },
    created() {
        // get steps based on product name
        this.formData.steps = getSteps(this.productName);
    },
    mounted() {
        this.applicationSettings.loadingAnimationSeconds = 0;
    },
    watch: {}
};
</script>
